import React, { useEffect } from 'react';
import { useState } from 'react';
import { store } from 'components/Store';
import { useContext } from 'react';
import useEmailComponentFunctions from 'components/Dashboard/Influence/CrmEmails/useEmailComponentFunctions';
import { useEmailState } from 'components/EmailStateProvider';
import { useNavigate, useParams } from 'react-router';
import time from 'utils/time';
import useAddMetaTags from 'components/Dashboard/utilities/addMetaTags';

const EngagementStatisticsDropdown = () => {
  const globalState = useContext(store);
  const { state: globalStateValue } = globalState;
  const { listDomainsVerified } = globalStateValue;

  const [sentEmails, setSentEmails] = useState([]);
  const navigate = useNavigate();

  const params = useParams();
  const { crmEmailId } = params;

  const { loadSentEmails } = useEmailComponentFunctions();
  const { emailState } = useEmailState();
  const { currentEmailDetails } = emailState;
  const { addMetaTags } = useAddMetaTags();

  const showSearchBarCondition =
    !!crmEmailId ||
    sentEmails.length > 0 ||
    listDomainsVerified?.verifiedDomains?.some((domain) => domain?.sentEmailCount > 0);

  // Only the bare /email-performance route needs the full list, to redirect to the latest sent campaign
  useEffect(() => {
    if (crmEmailId) return;
    const source = new AbortController();
    loadSentEmails({ setSentEmails, source });
    return () => {
      source.abort('Email performance api call canceled by the user');
    };
  }, [crmEmailId]);

  useEffect(() => {
    if (!crmEmailId && !!sentEmails.length) {
      navigate(`/people/email-performance/${sentEmails[0].crmEmailId}`);
    }
  }, [sentEmails, crmEmailId, navigate]);

  useEffect(() => {
    if (crmEmailId) {
      let title = `Email performance - Influence - PolicyMogul`;
      addMetaTags({ title, hash: null });
    }
  }, [crmEmailId]);

  const selectedEmail =
    crmEmailId && String(currentEmailDetails?.crmEmailId) === crmEmailId ? currentEmailDetails : null;
  let buttonText = `Sent on ${time(selectedEmail?.finishedSendingAt).formatShortDate()} at ${time(selectedEmail?.finishedSendingAt).format('H:mm')}`;

  return showSearchBarCondition ? (
    <div className='flex-centered flex-grow-1 justify-content-between' style={{ minWidth: 0 }}>
      <p className='mb-0 email-component-sub-nav-title text-overflow-ellipsis nowrap-item'>{selectedEmail?.subject}</p>
      <div className='d-md-block d-none ml-3'>
        <span
          className={`crm-table-item-state nowrap-item sent-state-badge border email-state-sent w-auto px-4 ${!selectedEmail?.finishedSendingAt ? 'text-transparent' : ''}`}
          style={{ fontSize: '16px' }}
        >
          {buttonText}
        </span>
      </div>
    </div>
  ) : (
    <div className='flex-grow-1'></div>
  );
};

export default EngagementStatisticsDropdown;
